"use strict";
/*
 * Created on 06 06 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of {@link ProductSiteNew}
 *
 * @author JMe
 */


var ProductSiteNewConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductSiteNewConverter, _DataObjectConverter_);

  function ProductSiteNewConverter() {
    _classCallCheck(this, ProductSiteNewConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSiteNewConverter).apply(this, arguments));
  }

  return ProductSiteNewConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductSiteNewConverter = ProductSiteNewConverter;